import { CREW, IMAGES } from "../../data/site";

export const Crew = () => {
    return (
        <section
            id="crew"
            data-testid="crew-section"
            className="py-24 md:py-32 bg-bone border-t border-line"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14 items-end reveal">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-moss mb-5">
                            <span className="h-px w-10 bg-moss inline-block align-middle mr-3" />
                            Meet the Crew
                        </div>
                        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] tracking-tight">
                            The same hands that{" "}
                            <span className="text-copper">show up on every job.</span>
                        </h2>
                    </div>
                    <p className="lg:col-span-5 text-muted_ink leading-relaxed">
                        No revolving door of day-labor. Our installers know spray foam, blow-in,
                        and crawl space encapsulation by name and by feel — and they&apos;ve been
                        doing this side-by-side for years.
                    </p>
                </div>

                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-line border border-line">
                    {CREW.map((c, idx) => (
                        <article
                            key={c.name}
                            data-testid={`crew-${c.name.toLowerCase()}`}
                            className="bg-white p-7 reveal flex flex-col justify-between min-h-[200px]"
                            style={{ transitionDelay: `${idx * 60}ms` }}
                        >
                            <div className="font-heading text-3xl font-extrabold tracking-tight">
                                {c.name}
                            </div>
                            <div>
                                <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-copper mb-2">
                                    {c.role}
                                </div>
                                <div className="text-sm text-muted_ink leading-relaxed">
                                    {c.note}
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center reveal">
                    <img
                        src={IMAGES.commercial}
                        alt="HAZ crew filling a commercial building"
                        loading="lazy"
                        className="w-full aspect-[16/10] object-cover"
                    />
                    <div>
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-moss mb-4">
                            On the job
                        </div>
                        <p className="font-heading text-2xl md:text-3xl font-bold leading-snug max-w-lg">
                            “Jamie and the crew filling a commercial building — three days, on
                            schedule, sealed and inspected.”
                        </p>
                        <p className="mt-4 text-muted_ink">
                            That&apos;s the standard for every project we run, residential or
                            commercial.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};
